export enum TtsControlEnum {
    playState = 'playState',
    pauseState = 'pauseState'
}
